function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.7627 4.01608L10.096 2.01608C10.0333 1.99741 9.96733 1.99741 9.90467 2.01608L3.238 4.01608C3.09667 4.05874 3 4.18808 3 4.33541V11.6687C3 14.6167 7.49467 17.2381 9.90133 17.9874C9.93333 17.9974 9.96667 18.0021 10 18.0021C10.0333 18.0021 10.0667 17.9974 10.0987 17.9874C12.5053 17.2387 17 14.6167 17 11.6687V4.33541C17 4.18808 16.9033 4.05874 16.7627 4.01608ZM15.6667 11.6687C15.6667 13.3814 12.74 15.6294 10.1127 16.5761C10.076 16.5894 10.038 16.5961 10 16.5961C9.932 16.5961 9.86533 16.5754 9.808 16.5354C9.71933 16.4727 9.66667 16.3714 9.66667 16.2627V10.0021H4.66667C4.48267 10.0021 4.33333 9.85274 4.33333 9.66874V5.32741C4.33333 5.18008 4.43 5.05008 4.57067 5.00808L9.904 3.40808C10.004 3.37808 10.114 3.39741 10.1987 3.46008C10.2833 3.52274 10.3333 3.62208 10.3333 3.72741V9.33541H15.3333C15.5173 9.33541 15.6667 9.48474 15.6667 9.66874V11.6687Z",
  fill: "#99A6B0"
});

const SvgShield = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield.87c8afd8.svg";
export { ForwardRef as ReactComponent };